import axios, { Canceler, CancelToken } from "axios";
import Axios from "helpers/Interceptor";
import { MessageItem } from "Hooks/useMaestroChat";

export const sendMessageToMaestro_api = async ({
    messages,
    brandId,
    chatId,
    onDownloadProgress,
    onCancel
}: {
    messages: MessageItem[];
    brandId: number;
    chatId: string;
    onDownloadProgress: (progressEvent: any) => void;
    onCancel: (canceler: Canceler) => void;
}) => {
    const requestPayload: any = {
        messages: messages,
        brandId: brandId,
        chatId: chatId
    };

    const accessToken = localStorage.getItem('accessToken');

    let headers: any = {
        'Content-Type': 'application/json',
        'brand-id': brandId,
    }

    if(accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`
    }

    await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_API_URL}/maestro`,
        data: requestPayload,
        headers: headers,
        responseType: 'text',
        cancelToken: new axios.CancelToken((cancel) => {
            onCancel(cancel);
        }),
        onDownloadProgress: onDownloadProgress
    });
}


export interface MaestroSystemMessage {
    id: string
    type: string
    message: string
    isVisible: boolean
    timestamp: number
}

export interface MaestroToolCall {
    name: string
    arguments: string
}

export interface MaestroMessage {
    id: string
    type: 'user' | 'assistant'
    content: string
    metadata?: {
        original_id?: number
        system_messages?: MaestroSystemMessage[];
        tool_calls?: MaestroToolCall[];
    }
    timestamp: number
}

export interface MaestroRelatedTasks {
    campaigns: any[]
    assets: any[]
}

export interface MaestroChatDetails {
    id: string
    brandId: number
    status: string
    title: string
    user_feedback: string
    conversationType: string
    messageCount: number
    startedAt: string
    lastActiveAt: string
    messages: MaestroMessage[]
    createdAt: string
    updatedAt: string
    relatedTasks: MaestroRelatedTasks
}

export interface MaestroChatApiResponse {
    success?: boolean
    isError?: boolean
    data: MaestroChatDetails
    [key: string]: any
}

export const loadChat_api = async ({
    chatId,
    brandId
}: {
    chatId: string
    brandId: number
}): Promise<MaestroChatApiResponse> => {
    const response = await Axios.post(`/maestro/${chatId}`, {
        brandId: brandId
    })

    return response
}